import styled from 'styled-components'

const DropdownStyle = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 10vh;
  color: ${(props) => props.theme.text};
  font-family: ${(props) => props.theme.font};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
  z-index: 10;

  transition: 0.25s;
  ${
    '' /* background-color: ${({ scrolled }) => (scrolled ? 'black' : 'transparent')}; */
  }
  background-color: black;

  p {
    padding-right: 0.5rem;
  }
`

export default DropdownStyle
